import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueI18nFilter from 'vue-i18n-filter'
import ru from '@/langs/ru.json'

Vue.use(VueI18n);
Vue.use(VueI18nFilter);


const i18n = new VueI18n({
  locale: 'ru',
  fallbackLocale: 'en'
});

i18n.setLocaleMessage('ru', ru);

export { i18n };
